"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11c0-5.521-4.067-10.092-9.37-10.88C13.1 1.04 12.557 1 12 1zm-1.571 19.423a8.57 8.57 0 01-6.95-9.317l4.705 4.743v1.132c0 1.245 1.01 2.263 2.245 2.263v1.18zm7.971-2.728a2.177 2.177 0 00-2-1.295h-1.1v-3.3c0-.605-.495-1.1-1.1-1.1H7.6V9.8h2.2c.605 0 1.1-.495 1.1-1.1V6.5h2.2c1.21 0 2.2-.99 2.2-2.2v-.208a8.57 8.57 0 013.1 13.603z" }), "Web");
//# sourceMappingURL=Web.js.map